import get from 'lodash/get';

export const getConfiguration = (key, valueIfMissing) => {
  const config = JSON.parse(window.APP_CONFIG || '{}');

  return get(config, key, valueIfMissing);
};
